import channelTypes from 'shared/constants/channel-types';
import { demoChannel, demoChannelEditor } from 'shared/constants/demo-channel';


export function isVODChannel(channelData) {
  return channelData.channelType === channelTypes.CHANNEL;
}

export function isYouTubeFeed(channelData) {
  return channelData.channelType === channelTypes.YOUTUBE_FEED;
}

export function hasTags(channelData) {
  const tags = _.get(channelData, 'statsInfo.tags');
  return !_.isEmpty(tags);
}

export function hasDescription(channelData) {
  return Boolean(channelData.description);
}

export function hasVideos(channelData) {
  return channelData.videosCount > 0;
}

export function isDemoChannel(channelId) {
  return _.includes([demoChannel.id, demoChannelEditor.id], channelId);
}



// WEBPACK FOOTER //
// ./src/shared/utils/channel-helpers.js